import {
    Box,

    Card,
    CardContent,
    Checkbox,
    ListItemText,
    MenuItem,
    TextField,
    Typography
} from "@material-ui/core";
import { Grid } from "@mui/material";
import Button from "components/CustomButtons/Button";
import { configUrl } from "config";
import { useEffect, useState } from "react";
import { getPredictedColleges } from "services/CollegePredictorServices/aiCollegePredictorService";
import { getCollegesByPercentile, getCollegesByRank } from "services/CollegePredictorServices/rankRangeFilterService";
import { exportToExcel } from "utils/exportExcel";

function CollegePredictorDashboard() {
    const [predictorType, setPredictorType] = useState("pcm");

    const [startPercentile, setStartPercentile] = useState("");

    const [endPercentile, setEndPercentile] = useState("");

    const [startRank, setStartRank] = useState("");

    const [endRank, setEndRank] = useState("");

    const [exportType, setExportType] = useState("percentile");

    const [branch, setBranch] = useState([]);
    const [category, setCategory] = useState("All");
    const [city, setCity] = useState([]);
    const [genderFilter, setGenderFilter] = useState("All");
    const [quotaFilter, setQuotaFilter] = useState("All");

    const [branchOptions, setBranchOptions] = useState([]);
    const [categoryOptions, setCategoryOptions] = useState([]);
    const [cityOptions, setCityOptions] = useState([]);
    const [collegeOptions, setCollegeOptions] = useState([]);   //@BSS- this is for display college filters dropdown
    const [loading, setLoading] = useState(false);
    const [colleges, setColleges] = useState([]);
    const [studentName, setStudentName] = useState("");
    const [typeOptions] = useState([
        {
            "code": "All",
            "name": "All"
        },
        {
            "code": "general",
            "name": "General",
        },
        {
            "code": "ladies",
            "name": "Ladies",
        }
    ]);
    const [quotaOptions] = useState([
        {
            "code": "All",
            "name": "All",
        },
        {
            "code": "H",
            "name": "Home University",
        },
        {
            "code": "O",
            "name": "Other than Home University",
        },
        {
            "code": "S",
            "name": "State Level",
        }
    ]);


    useEffect(() => {
        const fetchFilters = async () => {
            try {
                const response = await fetch(
                    `${configUrl.PredictorServer}/filters/${predictorType}`
                );

                const data = await response.json();


                const uniqueBranches = Array.from(
                    new Set((data?.branches || []).filter(item => item !== "All"))
                );

                setBranchOptions(uniqueBranches);

                if (predictorType === "jee") {
                    setCategoryOptions([
                        "JEE",
                        "NEET",
                        "MHT-CET",
                        "MHT-CET-PCM",
                        "MHT-CET-PCB"
                    ]);
                } else {
                    setCategoryOptions(data?.categories || []);
                }

                setCityOptions(data?.cities || []);

                const collegeList = Object.entries(
                    data?.collegesWithCodes || {}
                )
                    .map(([code, name]) => ({
                        code,
                        name
                    }))
                    .sort((a, b) => a.name.localeCompare(b.name));

                setCollegeOptions(collegeList);

            } catch (error) {
                console.error("Error fetching filter options:", error);
            }
        };

        fetchFilters();

    }, [predictorType]);
    // handlers
    const validateSearch = () => {

        if (!studentName.trim()) {
            alert("Please enter Student Name.");
            return false;
        }

        if (exportType === "percentile") {

            if (!startPercentile || !endPercentile) {
                alert("Please enter Start and End Percentile.");
                return false;
            }

            if (Number(startPercentile) >= Number(endPercentile)) {
                alert("End Percentile should be greater than Start Percentile.");
                return false;
            }
            if (
                Number(startPercentile) < 0 ||
                Number(endPercentile) > 100
            ) {
                alert("Percentile must be between 0 and 100.");
                return false;
            }

        }

        if (exportType === "rank") {

            if (!startRank || !endRank) {
                alert("Please enter Start and End Rank.");
                return false;
            }

            if (Number(startRank) >= Number(endRank)) {
                alert("End Rank should be greater than Start Rank.");
                return false;
            }
            if (
                Number(startRank) <= 0 ||
                Number(endRank) <= 0
            ) {
                alert("Rank must be greater than 0.");
                return false;
            }

        }

        if (exportType === "aiPredictor") {

            if (!startRank) {
                alert("Please enter Rank.");
                return false;
            }
            if (Number(startRank) <= 0) {
                alert("Please enter a valid rank.");
                return false;
            }

        }

        return true;
    };
    const handleSearch = async () => {

        try {

            if (!validateSearch()) return;
            setLoading(true);

            let data = [];
            const selectedBranches =
                branch.length ? branch : ["All"];

            const selectedCities =
                city.length ? city : ["All"];

            if (exportType === "percentile") {

                if (predictorType === "pharma") {

                    data = await getCollegesByPercentile(
                        predictorType,
                        Number(startPercentile),
                        Number(endPercentile),
                        selectedBranches,
                        category,
                        selectedCities,
                        genderFilter,
                        quotaFilter
                    );

                } else {

                    data = await getCollegesByPercentile(
                        predictorType,
                        Number(startPercentile),
                        Number(endPercentile),
                        selectedBranches,
                        category,
                        selectedCities,
                        genderFilter,
                        quotaFilter
                    );
                }

            } else if (exportType === "rank") {

                if (predictorType === "pharma") {

                    data = await getCollegesByRank(
                        predictorType,
                        Number(startRank),
                        Number(endRank),
                        selectedBranches,
                        category,
                        selectedCities,
                        genderFilter,
                        quotaFilter
                    );

                } else {

                    data = await getCollegesByRank(
                        predictorType,
                        Number(startRank),
                        Number(endRank),
                        selectedBranches,
                        category,
                        selectedCities,
                        genderFilter,
                        quotaFilter
                    );
                }

            } else if (exportType === "aiPredictor") {

                const aiObj = {
                    rank: Number(startRank),
                    branches: branch.length > 0 ? branch : ["All"],
                    category,
                    category_gender_filter: genderFilter,
                    category_region_filter: quotaFilter,
                    city: city.length > 0 ? city : ["All"]
                };

                console.log("AI Predictor Request:", aiObj);

                data = await getPredictedColleges(
                    predictorType,
                    aiObj.rank,
                    aiObj.branches,
                    aiObj.category,
                    aiObj.city,
                    aiObj.category_gender_filter,
                    aiObj.category_region_filter
                );
            }
            else {

                data = await getCollegesByRank(
                    predictorType,
                    Number(startRank),
                    Number(endRank),
                    selectedBranches,
                    category,
                    selectedCities,
                    genderFilter,
                    quotaFilter
                );

            }
            const sortedColleges = [...(data || [])].sort((a, b) => {
                const rankA = Number(a["Highest Rank"] ?? a.Rank ?? Number.MAX_SAFE_INTEGER);
                const rankB = Number(b["Highest Rank"] ?? b.Rank ?? Number.MAX_SAFE_INTEGER);

                return rankA - rankB; // Ascending
            });

            setColleges(sortedColleges);
            // setColleges(data || []);

        }
        catch (err) {

            console.log(err);

        }
        finally {

            setLoading(false);

        }

    };
    const handleExportClick = () => {
        const genderLabel = typeOptions.find(item => item.code === genderFilter)?.name || genderFilter;
        const quotaLabel = quotaOptions.find(item => item.code === quotaFilter)?.name || quotaFilter;
        if (colleges.length === 0) {
            alert("Please search colleges before exporting.");
            return;
        }
        exportToExcel(
            colleges,
            "College Predictor",
            {
                studentName,
                category,
                city: city.length > 0 ? city.join(", ") : "All",
                branches: branch.length > 0 ? branch.join(", ") : "All",
                startPercentile,
                endPercentile,
                startRank,
                endRank,
                searchType: exportType,
                // exportType === "percentile"
                //     ? "Percentile Range"
                //     : exportType === "rank"
                //         ? "Rank Range"
                //         : "AI Predictor",
                quota: quotaLabel,
                seatType: genderLabel
            }
        );
    };


    return (
        <Box p={3}>
            <Box mb={4}>
                <Typography
                    variant="h5"
                    style={{
                        fontWeight: 600,
                        marginBottom: 24
                    }}
                >
                    College Predictor Dashboard
                </Typography>

                <Grid container spacing={3}>

                    <Grid item xs={12} sm={6} md={3}>
                        <TextField
                            select
                            fullWidth
                            label="Predictor Type"
                            value={predictorType}
                            onChange={(e) => setPredictorType(e.target.value)}
                            variant="outlined"
                            size="small"
                        >
                            <MenuItem value="pcm">MHT CET</MenuItem>
                            <MenuItem value="jee">JEE</MenuItem>
                            <MenuItem value="pharma">Pharmacy</MenuItem>
                            <MenuItem value="mba">MBA</MenuItem>
                        </TextField>
                    </Grid>

                    <Grid item xs={12} sm={6} md={3}>
                        <TextField
                            select
                            fullWidth
                            label="Search Type"
                            value={exportType}
                            onChange={(e) => setExportType(e.target.value)}
                            variant="outlined"
                            size="small"
                        >
                            <MenuItem value="percentile">
                                Percentile Range
                            </MenuItem>
                            <MenuItem value="rank">
                                Rank Range
                            </MenuItem>
                            <MenuItem value="aiPredictor">
                                Preferences
                            </MenuItem>
                        </TextField>
                    </Grid>

                    {exportType === "percentile" ? (
                        <>
                            <Grid item xs={12} sm={6} md={3}>
                                <TextField
                                    fullWidth
                                    variant="outlined"
                                    size="small"
                                    label="Start Percentile"
                                    value={startPercentile}
                                    onChange={(e) =>
                                        setStartPercentile(e.target.value)
                                    }
                                />
                            </Grid>

                            <Grid item xs={12} sm={6} md={3}>
                                <TextField
                                    fullWidth
                                    variant="outlined"
                                    size="small"
                                    label="End Percentile"
                                    value={endPercentile}
                                    onChange={(e) =>
                                        setEndPercentile(e.target.value)
                                    }
                                />
                            </Grid>
                        </>
                    ) : exportType === "rank" ? (
                        <>
                            <Grid item xs={12} sm={6} md={3}>
                                <TextField
                                    fullWidth
                                    variant="outlined"
                                    size="small"
                                    label="Start Rank"
                                    value={startRank}
                                    onChange={(e) =>
                                        setStartRank(e.target.value)
                                    }
                                />
                            </Grid>

                            <Grid item xs={12} sm={6} md={3}>
                                <TextField
                                    fullWidth
                                    variant="outlined"
                                    size="small"
                                    label="End Rank"
                                    value={endRank}
                                    onChange={(e) =>
                                        setEndRank(e.target.value)
                                    }
                                />
                            </Grid>
                        </>
                    ) : (
                        <Grid item xs={12} sm={6} md={3}>
                            <TextField
                                fullWidth
                                label="Rank"
                                value={startRank}
                                onChange={(e) => setStartRank(e.target.value)}
                                variant="outlined"
                                size="small"
                            />
                        </Grid>)}

                    <Grid item xs={12} sm={6} md={3}>
                        <TextField
                            select
                            fullWidth
                            SelectProps={{
                                multiple: true,
                                value: branch,
                                onChange: (e) => setBranch(e.target.value),
                                renderValue: (selected) =>
                                    selected.length === 0
                                        ? "All"
                                        : selected.join(", ")
                            }}
                            variant="outlined"
                            size="small"
                            label="Branches"
                        >
                            {branchOptions.map((item) => (
                                <MenuItem
                                    key={item}
                                    value={item}
                                >
                                    <Checkbox
                                        checked={branch.indexOf(item) > -1}
                                        color="primary"
                                    />
                                    <ListItemText primary={item} />
                                </MenuItem>
                            ))}
                        </TextField>
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                        <TextField
                            select
                            fullWidth
                            variant="outlined"
                            size="small"
                            label="Category"
                            value={category}
                            onChange={(e) => setCategory(e.target.value)}
                        >
                            <MenuItem value="All">All</MenuItem>

                            {categoryOptions.map((item) => (
                                <MenuItem key={item} value={item}>
                                    {item}
                                </MenuItem>
                            ))}
                        </TextField>
                    </Grid>

                    <Grid item xs={12} sm={6} md={3}>
                        <TextField
                            select
                            fullWidth
                            SelectProps={{
                                multiple: true,
                                value: city,
                                onChange: (e) => setCity(e.target.value),
                                renderValue: (selected) =>
                                    selected.length === 0
                                        ? "All"
                                        : selected.join(", ")
                            }}
                            variant="outlined"
                            size="small"
                            label="Cities"
                        >
                            {cityOptions.map((item) => (
                                <MenuItem
                                    key={item}
                                    value={item}
                                >
                                    <Checkbox
                                        checked={city.indexOf(item) > -1}
                                        color="primary"
                                    />
                                    <ListItemText primary={item} />
                                </MenuItem>
                            ))}
                        </TextField>
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                        <TextField
                            select
                            fullWidth
                            variant="outlined"
                            size="small"
                            label="Seat Type"
                            value={genderFilter}
                            onChange={(e) => setGenderFilter(e.target.value)}
                        >
                            {typeOptions.map((item) => (
                                <MenuItem key={item.code} value={item.code}>
                                    {item.name}
                                </MenuItem>
                            ))}
                        </TextField>
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                        <TextField
                            select
                            fullWidth
                            variant="outlined"
                            size="small"
                            label="Quota"
                            value={quotaFilter}
                            onChange={(e) => setQuotaFilter(e.target.value)}
                        >
                            {quotaOptions.map((item) => (
                                <MenuItem key={item.code} value={item.code}>
                                    {item.name}
                                </MenuItem>
                            ))}
                        </TextField>
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                        <TextField
                            fullWidth
                            variant="outlined"
                            size="small"
                            label="Student Name"
                            value={studentName}
                            onChange={(e) => setStudentName(e.target.value)}
                        />
                    </Grid>
                    <Grid
                        item
                        xs={12}
                        style={{
                            display: "flex",
                            justifyContent: "flex-end",
                            gap: 16,
                            marginTop: 15
                        }}
                    >

                        <Button
                            variant="outlined"
                            color="primary"
                            onClick={handleSearch}
                            disabled={loading}
                        >
                            {loading ? "Searching..." : "Search"}
                        </Button>

                        <Button
                            variant="contained"
                            color="primary"
                            onClick={handleExportClick}
                            disabled={colleges.length === 0}
                        >
                            Export Excel
                        </Button>

                    </Grid>
                </Grid>
            </Box>
            {colleges.length > 0 && (
                <Box mt={5}>
                    <Typography
                        variant="h6"
                        style={{
                            marginBottom: 20,
                            fontWeight: 600
                        }}
                    >
                        Search Results ({colleges.length})
                    </Typography>

                    <Grid container spacing={3}>
                        {colleges.map((college, index) => (
                            <Grid
                                item
                                xs={12}
                                sm={6}
                                md={4}
                                key={index}
                            >
                                <Card
                                    elevation={3}
                                    style={{
                                        borderRadius: 12,
                                        position: "relative",
                                        overflow: "visible",
                                        height: "100%"
                                    }}
                                >
                                    {/* Top Strip */}

                                    <Box
                                        display="flex"
                                        justifyContent="space-between"
                                        bgcolor="#de2668"
                                        color="#fff"
                                        px={2}
                                        py={1}
                                    >
                                        <Typography variant="caption">
                                            {college.Category}
                                        </Typography>

                                        <Typography variant="caption">
                                            Rank: {college["Highest Rank"]}
                                        </Typography>

                                        <Typography variant="caption">
                                            {Number(
                                                college["Highest Percentile"]
                                            ).toFixed(2)}
                                        </Typography>
                                    </Box>

                                    <CardContent>

                                        <Typography
                                            variant="subtitle1"
                                            style={{
                                                fontWeight: 700,
                                                marginBottom: 10
                                            }}
                                        >
                                            {college.AbbreviatedName ||
                                                college.College}

                                            {" ("}
                                            {college["College Code"]}
                                            {")"}
                                        </Typography>

                                        <Typography
                                            variant="body2"
                                            color="textSecondary"
                                        >
                                            {college.Branch}

                                            {" ("}
                                            {college["Branch Code"]}
                                            {")"}
                                        </Typography>

                                        <Typography
                                            variant="body2"
                                            style={{
                                                marginTop: 10
                                            }}
                                        >
                                            Overall Seats :
                                            {" "}
                                            <strong>
                                                {college.SI}
                                            </strong>
                                        </Typography>

                                    </CardContent>
                                </Card>
                            </Grid>
                        ))}
                    </Grid>
                </Box>
            )}
        </Box>
    );
}

export default CollegePredictorDashboard;